import { vec3 } from "pex-math";
import random from "pex-random";

function generateBark(
  lastRing,
  { seed = 0, frequency = 1, octaves = 5, amplitude = 1 }
) {
  // console.log("generateBark", frequency);
  const positions = [];
  const cells = [];

  const vertexCount = lastRing.spline.length * 2;
  random.seed(seed);

  // const lastIndex = lastRing.spline;
  lastRing.spline.forEach((p, i) => {
    // let t = (frequency * i) / lastRing.spline.length;
    let noiseSum = 0;
    let amplitudeSum = 0;
    let amp = 1;
    let freq = frequency;
    for (let k = 0; k < octaves; k++) {
      let noise = random.noise3(p[0] * freq, p[1] * freq, 0);
      noise *= amp;
      amplitudeSum += amp;
      noiseSum += noise;
      freq *= 2;
      amp *= 0.5;
    }
    noiseSum /= amplitudeSum;
    noiseSum = noiseSum * 0.5 + 0.5;
    noiseSum = Math.max(0, noiseSum);
    noiseSum *= amplitude;
    const r1 = 0.1;
    const r2 = 0.1 + noiseSum;
    const ci = i * 2;
    const cp = vec3.scale(vec3.normalize([...p]), r1);
    const np = vec3.scale(vec3.normalize([...p]), r2);
    vec3.add(cp, p);
    vec3.add(np, p);

    const ni = ci + 1;
    const nextI = (ci + 2) % vertexCount;
    const nextNI = (ci + 3) % vertexCount;
    positions.push(cp);
    positions.push(np);
    cells.push([ci, nextNI, ni]);
    cells.push([ci, nextI, nextNI]);
  });

  return {
    positions,
    cells,
  };
}

export default generateBark;
